import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { RelativityField, RelativityFolder, RelativityWorkspace } from '../types/relativitySettings';

export function useRelativityWorkspaces(projectId: string) {
  return useQuery({
    queryKey: ['relativity-workspaces', projectId],
    queryFn: () => api.get<RelativityWorkspace[]>(`/project/${projectId}/relativity/workspace`),
    enabled: !!projectId,
  });
}

export function useRelativityWorkspaceFields(projectId: string, workspaceId: string | undefined) {
  return useQuery({
    queryKey: ['relativity-workspace-fields', projectId, workspaceId],
    queryFn: () => api.get<RelativityField[]>(`/project/${projectId}/relativity/workspace/${workspaceId}/fields`),
    enabled: !!projectId && !!workspaceId,
  });
}

export function useRelativityWorkspaceFolders(projectId: string, workspaceId: string | undefined) {
  return useQuery({
    queryKey: ['relativity-workspace-folders', projectId, workspaceId],
    queryFn: () => api.get<RelativityFolder[]>(`/project/${projectId}/relativity/workspace/${workspaceId}/folders`),
    enabled: !!projectId && !!workspaceId,
  });
}
